export default __webpack_public_path__ + "static/apple-798ad8400cb1b29cc9bf909b2e6eaaf4.svg";